const NS = 'CareersMapBlock';
const CLS = 'careersMapBlock';

export class CareersMapBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$dot = this.$element.find(`.${CLS}-dot`)
		this.siteId = this.$element.data('siteId');
		this.regionApi = this.$element.data('region');
		this.regionData = {};

		this.fetchData()
			.then(() => {
				this.bindDotClickEvents();
				this.bindOutsideClickEvent();
			});
	}

	async fetchData() {
		var response = await fetch(this.regionApi+"?siteId="+this.siteId);
		var data = await response.json();
		data.regions.forEach(item => {
			this.regionData[item.region] = item;
			var idName = this.regionData[item.region].region;
			idName = idName .replace(/\s+/g, '-');
			$('#'+idName ).css('display', 'block');
		});
	}

	bindDotClickEvents() {
		var This = this;
		this.$dot.on('click', function (e) {
			e.stopPropagation();
			var originalRegion = Object.keys(This.regionData).find(
				name => name.replace(/\s+/g, '-') === $(this).attr('id') 
			);
			if (!originalRegion) return;

			This.$element.find('.info-box').hide();
			var {description} = This.regionData[originalRegion];
			var $infoBox = This.$element.find(`#info-`+$(this).attr('id'));
			$infoBox.html(`
				<span class="close-btn" style="position: absolute; top: 5px; right: 10px; cursor: pointer;">✕</span>
				<h4>${originalRegion}</h4>
				<p>${description}</p>
			`).show();
			$infoBox.find('.close-btn').on('click', function (e) {
				e.stopPropagation();
				$infoBox.hide();
			});
		});
	}

	bindOutsideClickEvent() {
		$(document).on('click', () => {
			this.$element.find('.info-box').hide();
		});

		this.$element.on('click', (e) => {
			e.stopPropagation();
		});
	}
}